/* @flow */
/**
 * index.js
 * Written by: Alex Kasemir
 */

import * as saveQueryParams from './saveQueryParams';
import * as removeUrlParam from './removeUrlParam';
import * as setReferralToken from './setReferralToken';
import * as setABLeg from './setABLeg';
import * as setDeviceType from './setDeviceType';
import * as setSignUpModal from './setSignUpModal';
import * as setShareContent from './setShareContent';


export default {
  ...saveQueryParams,
  ...removeUrlParam,
  ...setReferralToken,
  ...setABLeg,
  ...setDeviceType,
  ...setSignUpModal,
  ...setShareContent,
};
